module.exports = __webpack_public_path__ + "assets/img/gift@1,5x.c5aa7ee8.svg";